module.exports = __webpack_public_path__ + "static/media/participant_id_icon.bd769548.png";